import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppFloat from '@/components/feature/WhatsAppFloat';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import DifferentialsSection from './components/DifferentialsSection';
import MenuSection from './components/MenuSection';
import EnvironmentSection from './components/EnvironmentSection';
import GallerySection from './components/GallerySection';
import LocationSection from './components/LocationSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <DifferentialsSection />
        <MenuSection />
        <EnvironmentSection />
        <GallerySection />
        <LocationSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}